import * as sha256 from "node-forge/lib/sha256";

import { environment } from "../../../environments/environment";

export const encrypt = (data: string): string => {
  if (!data) {
    return data;
  }

  const md = sha256.create();
  const value = `${data}${environment.SALT}`;

  md.update(value);

  return md.digest().toHex();
};
